import React, {useEffect, useState} from 'react'
import '../css/ButtonSearch.scss'

export default props => {
    const {
        onClick,
        active,
        text,
        id
    } = props

    const [isClicked, setIsClicked] = useState(false)

    const handleClick = () => {
        if (isClicked) return
        setIsClicked(true)
        onClick()
    }

    useEffect(() => {
        if(!active && isClicked) setIsClicked(false)
    }, [active, isClicked])

    return (
        <button
            type='button'
            id={id}
            className='button-search-container'
            disabled={isClicked && active}
            aria-busy={isClicked && active}
            onClick={handleClick}
        >
            <span className={`button-search-content${isClicked && active ? ' loading' : ''}`}>
                {isClicked && active? 
                    <span className='canarias-spinner-inline' aria-hidden='true'></span>
                 : text }
            </span>
        </button>
    )
}
